import { transformacion } from 'lib.common';
import { apiRestUrl } from 'src/config/keys';
import { format } from 'date-fns';
import { paramsGetTipoCambioSUNAT } from '../../bussines/params/TipoCambioSUNAT.params';
import { TipoCambioSUNAT } from '../../bussines/entities/tipoCambioSUNAT.entity';
export class TipoCambioSUNATExpressProvider {
   private apiKey: string;
   constructor(apiKey: string) {
      this.apiKey = apiKey;
   }
   async getTipoCambioSUNAT(params: paramsGetTipoCambioSUNAT): Promise<TipoCambioSUNAT> {
      try {
         const fechaFormateada = format(params.fecha, 'yyyy-MM-dd');
         let url = transformacion.appendUrl(apiRestUrl, `/tipoCambio`);
         url.searchParams.append('moneda', params.moneda);
         url.searchParams.append('fecha', fechaFormateada);
         const response = await fetch(url, {
            headers: {
               'Content-Type': 'application/json',
               dsapikey: this.apiKey
            }
         });
         if (response.ok) {
            const data = await response.json();
            if (data) {
               return data;
            }
            throw new Error(`No se encontraron datos`);
         }
         const errorText = await response.text();
         throw new Error(`Error ${response.status}: ${response.statusText} - ${errorText}`);
      } catch (error) {
         throw error;
      }
   }
}
